import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UITextInput from "components/ui/UITextInput";
import React, { useState } from "react";
import { useRoute, useParams } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function EnterPinView
 * @return {React.Component}
 * @exported true
 * @description The second workflow step for the SetPinPage
 */
export default function EnterPinView(props) {
  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const submit = evt => navigate(`/home/setpin/setpinconfirmation/${ cardID }`);
  const cancel = evt => navigate(`/home/recenttransactions/${ cardID }`);

  const [ enterPin, setEnterPin ] = useState("");
  const [ confirmPin, setConfirmPin ] = useState("");

  const enterChange = value => setEnterPin(value);
  const confirmChange = value => setConfirmPin(value);

  const submitClass = !(enterPin.length > 0 && confirmPin.length > 0) ? "disabled" : "";

  return(
    <div className="enter-pin-view">
      <FormContainer>
        <FormRow>
          <p>Enter your 4-digit PIN</p>
        </FormRow>
        <FormRow>
          <UITextInput placeholderText="Enter new PIN*" type="password" value={ enterPin } onChange={ enterChange } />
        </FormRow>
        <FormRow>
          <UITextInput placeholderText="Confirm new PIN*" type="password" value={ confirmPin } onChange={ confirmChange } />
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Submit" className={ submitClass } onClick={ submit }/>
          <UICancelButton text="Cancel" onClick={ cancel }/>
        </FormButtonContainer>
      </FormContainer>
    </div>
  );
}